import api from '@/services/api';

const ENDPOINT_BASE = 'cotizacion';

const cotizacion_costos_service = {
  async editarCostoManual(codigoCotizacion, idCosto, dto) {
    try {
      const response = await api.patch(
        `/${ENDPOINT_BASE}/${codigoCotizacion}/costos/${idCosto}/editar`,
        dto,
      );
      return response.data;
    } catch (error) {
      console.error('[SERVICE] Error en editarCostoManual:', error);
      throw error;
    }
  },

  async restaurarCostoManual(codigoCotizacion, idCosto) {
    try {
      const response = await api.patch(
        `/${ENDPOINT_BASE}/${codigoCotizacion}/costos/${idCosto}/restaurar`,
      );
      return response.data;
    } catch (error) {
      console.error('[SERVICE] Error en restaurarCostoManual:', error);
      throw error;
    }
  },

  async crearCostoPersonalizado(codigoCotizacion, dto) {
    try {
      const response = await api.post(
        `/${ENDPOINT_BASE}/${codigoCotizacion}/costos/personalizado`,
        dto,
      );
      return response.data;
    } catch (error) {
      console.error('[SERVICE] Error en crearCostoPersonalizado:', error);
      throw error;
    }
  },

  async eliminarCostoPersonalizado(codigoCotizacion, idCosto) {
    try {
      const response = await api.delete(
        `/${ENDPOINT_BASE}/${codigoCotizacion}/costos/${idCosto}/personalizado`,
      );
      return response.data;
    } catch (error) {
      console.error('[SERVICE] Error en eliminarCostoPersonalizado:', error);
      throw error;
    }
  },

  async marcarAdicional(codigoCotizacion, ids, esAdicional) {
    try {
      const response = await api.patch(`/${ENDPOINT_BASE}/${codigoCotizacion}/costos/adicional`, {
        Ids: ids,
        Adicional: esAdicional,
      });
      return response.data;
    } catch (error) {
      console.error('[SERVICE] Error en marcarAdicional:', error);
      throw error;
    }
  },

  async igualarPrecio(codigoCotizacion, idCotizacionCantidad, precioReferencia) {
    try {
      const dto =
        precioReferencia !== undefined && precioReferencia !== null
          ? { PrecioReferencia: precioReferencia }
          : undefined;
      const response = await api.patch(
        `/${ENDPOINT_BASE}/${codigoCotizacion}/igualar-precio/${idCotizacionCantidad}`,
        dto,
      );
      return response.data;
    } catch (error) {
      console.error('[SERVICE] Error en igualarPrecio:', error);
      throw error;
    }
  },

  async deshacerIgualarPrecio(codigoCotizacion, idCotizacionCantidad) {
    try {
      const response = await api.patch(
        `/${ENDPOINT_BASE}/${codigoCotizacion}/deshacer-igualar-precio/${idCotizacionCantidad}`,
      );
      return response.data;
    } catch (error) {
      console.error('[SERVICE] Error en deshacerIgualarPrecio:', error);
      throw error;
    }
  },

  async exportarGrillaPdf(codigo, payload) {
    try {
      const response = await api.post(`/reportes/grilla-costos/${codigo}/pdf`, payload, {
        timeout: 2 * 60 * 1000,
      });
      return response.data;
    } catch (error) {
      console.error('[SERVICE] Error en exportarGrillaPdf:', error);
      throw error;
    }
  },
};

export default cotizacion_costos_service;
